import {axiosService} from "../axios";
import {chatService} from "./chatService";

export const assistantService = {

    fetchPreview: (exportId) => {
        return axiosService.get(`/api/assistant/${exportId}/preview`)
    },

    ask: (objectType, objectId, message, sheetName) => {
        return axiosService.post(`/api/assistant/${objectType}/${objectId}/ask`, {message: message, sheetName: sheetName});
    },

    getHistory: (objectType, objectId) => {
        return new Promise((resolve, reject) => {
            return axiosService.get(`/api/assistant/${objectType}/${objectId}/messages`).then((response) => {

                // we need to remap it like this because of the backend
                const messages = response.data.map((message, id) => {
                    return {
                        id: id,
                        message: chatService.convertToJson(message.message),
                        status: message.status,
                        role: message.role
                    };
                });

                resolve(messages);
            }).catch((error) => {;
                console.error("Error fetching history:", error);
                reject(error);
            });
        });
    },

    getSuggestions: (objectType, objectId, sheetName) => {
        return axiosService.post(`/api/assistant/${objectType}/${objectId}/suggestions`, {sheetName: sheetName});
    },

    image: (objectType, objectId, imageName) => {

        return axiosService.get(`/api/assistant/${objectType}/${objectId}/ask/image/${imageName}`, {
            responseType: "blob"
        });

    },

    downloadDataFrame: (objectType, objectId, filename) => {
        return axiosService.get(`/api/assistant/${objectType}/${objectId}/ask/dataframe/${filename}`, {
            responseType: "blob"
        });
    }

}